import { Auctions } from '@sorare/marketplace/src/components/market/Auctions';

import { SelectedLeaderboardBanner } from 'components/searchCards/SelectedLeaderboardBanner';

const AuctionsPage = () => {
  return <Auctions banner={<SelectedLeaderboardBanner />} />;
};

export default AuctionsPage;
